import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RestricoesLgpdComponent } from './restricoes-lgpd.component';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { ToastModule } from 'primeng/toast';
import {DialogModule} from 'primeng/dialog';

@NgModule({
  imports: [
    CommonModule,
    ToastModule,
    CalendarModule,
    TableModule,
    PaginatorModule,
    DialogModule
  ],
  declarations: [RestricoesLgpdComponent]
})
export class RestricoesLgpdModule { }
